import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styled from 'styled-components';
import Burger from './Burger';
import { useConfig } from "./Context/ConfigContext";

const Nav = styled.nav`
  width: 100%;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items:center; 

  .logo {
    padding: 15px 0;
  }
`


const Navbar = () => {
  const [fixHeader, setFixHeader] = useState(false)
  let location = useLocation()
  // const { config, loading, error } = useConfig();
  

  let slug = document.URL.split("/")[3];
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > 20) {
      setFixHeader(true)
    } else {
      setFixHeader(false)
    }
  })

  let innerheader = (slug) ? "innerheader" : "";
  return (
    <>
      <div className={`siteheader ${fixHeader ? "header-fixed" : ""}` +" "+ innerheader }>
        <div className="container">
          <div className="row">
            <div className={`col-sm-12 mainmenu ${location.pathname === '/' && "homemenubar"}`}>
              <Nav>
                <div className="logo">
                  <NavLink className="navbar-brand" to="/">
                    <img src={'/images/logo.png'} className="logoimg defaultlogo" alt="Logo" title="logo" 
                     width={192} height={60}
                     style={{ width: "revert-layer", height: "auto" }}
                     />
                    <img src={'/images/logoclr.png'} className="logoimg hdrfxdlogo" alt="Logo" title="logo"  
                     width={192} height={60}
                     style={{ width: "revert-layer", height: "auto" }} />
                  </NavLink>
                </div>
                <Burger />
              </Nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
